import axios from 'axios'

const request = axios.create({
  baseURL: window.env && window.env.baseHost
})

export default request
